var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPickup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/pick up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.56 9C7.56 10.69 6.18999 12.06 4.5 12.06C2.81001 12.06 1.44 10.69 1.44 9C1.44 7.31001 2.81001 5.94 4.5 5.94C6.18999 5.94 7.56 7.31001 7.56 9ZM8.94304 9.71794C8.59928 11.862 6.74093 13.5 4.5 13.5C2.01472 13.5 0 11.4853 0 9C0 6.51472 2.01472 4.5 4.5 4.5C6.74105 4.5 8.59948 6.1382 8.9431 8.28241C8.96193 8.28093 8.98096 8.28018 9.00018 8.28018H17.1002C17.4978 8.28018 17.8202 8.60253 17.8202 9.00018C17.8202 9.39782 17.4978 9.72018 17.1002 9.72018H9.00018C8.98095 9.72018 8.96189 9.71942 8.94304 9.71794Z",
    fill: "#CDCDCD"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/Pickup.9f90873cbddc1a72e9e13eefe442d653.svg";
export { ForwardRef as ReactComponent };